import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTicketStatusesByAttribute } from "../../../services/TicketStatus";
import { useTheme } from "../../../components/hooks/useTheme";
import { Tabs } from "../../../components/common/Tabs";
import { SupportTicketsList } from "./SupportTicketsList";
import colorConfigs from "../../../configs/colorConfigs";

type TabType = {
  id: number,
  label: string
}

const filterItems = [
  {
    id: 0,
    label: "Subject",
  },
]

export const SupportTickets = () => {
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [tabs, setTabs] = useState<TabType[]>([{
    id: 0,
    label: "All"
  }]);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [activeTabLable, setActiveTabLable] = useState<string>("All");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [searchValue, setSearchValue] = useState<string>("");
  const [ticketsFilterValue, setTicketsFilterValue] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);

  const hanbleTabChange = (index: number, tab: any) => {
    setActiveIndex(tab?.id || index);
    setCurrentIndex(index);
    setActiveTabLable(tab?.label);
    setSearchValue("");
    setSelectedFilter(filterItems[0].label);
    setTicketsFilterValue(0);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    })
  }

  useEffect(() => {
    const attribute = 'Incidents';
    getTicketStatusesByAttribute(attribute)
      .then((res) => {
        res.data.reverse().forEach((item: any) => {
          setTabs((tabs) => [
            ...tabs,
            {
              id: item.id,
              label: item?.status,
            },
          ]);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="flex items-center justify-end">
          <div className="flex items-center gap-2.5">
            <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
              onClick={() => navigate("/support/new-support-ticket")}
            >
              <span className="material-symbols-outlined text-[25px] font-light">
                add
              </span>
              <span className="text-xs font-medium">Support Ticket</span>
            </button>

          </div>
        </div>
        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index, tab) => hanbleTabChange(index, tab)} activeIndex={currentIndex} />
        </div>

        <div>
          <SupportTicketsList
            activeIndex={activeIndex}
            activeTabLable={activeTabLable}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            ticketsFilterValue={ticketsFilterValue}
            setTicketsFilterValue={setTicketsFilterValue}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            filterItems={filterItems}
          />
        </div>
      </div>
    </div>
  );
};
